module.exports = __webpack_public_path__ + "assets/media/google-play.f0f5174b.svg";